import { useEffect, useState } from "react";
import { Grid, Typography } from "../../basics";
import { IHeaderProps } from "./types";
import { StyledHeader } from "./styled";
import { intl } from "src/internationalization/intl";

const Header = (props: IHeaderProps) => {
    const [now, setNow] = useState<Date>(new Date());

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setNow(new Date());
        }, 60 * 1000);

        return () => window.clearInterval(intervalId);
    }, []);

    const formattedDay = now.toLocaleDateString("pt-BR");
    const formattedTime = now.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <StyledHeader>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography
                        variant="h3"
                        sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        {props.title}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        {`${intl("welcomeText1")}, ${props.userName}. ${intl("todayIs")} ${formattedDay}. ${intl("itIsTime")} ${formattedTime}.`}
                    </Typography>
                </Grid>
                <Grid item>{props.children}</Grid>
            </Grid>
        </StyledHeader>
    );
};

export { Header };